import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface AuthApi {
  login(email: string, password: string): Observable<{ uid: string }>;
  logout(): Observable<void>;
}

export const AUTH_API = new InjectionToken<AuthApi>('AUTH_API');
